import React from 'react'
import { FormError } from 'components/atoms'
import styles from './FormInput.module.sass'

interface Props {
  type?: 'text' | 'number' | 'email'
  placeholder?: string
  name?: string
  value?: string | number
  className?: string
  readOnly?: boolean
  disabled?: boolean
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const FormInput = (props: Props) => {
  const {
    type = 'text',
    placeholder = '',
    name = '',
    value = '',
    className = '',
    readOnly = false,
    disabled = false,
    status = '',
    errorMessage = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
  } = props

  const classNames = `
    ${styles.formInput} 
    ${status ? styles[`formInput--${status}`] : ''}
    ${className}`

  return (
    <div className={classNames}>
      <input
        type={type}
        name={name}
        value={value}
        className={styles.input}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
      />
      <FormError
        className={styles.error}
        message={errorMessage}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormInput
